import { render, staticRenderFns } from "./SystemCheck.vue?vue&type=template&id=ccb17fb2&scoped=true&lang=pug"
import script from "./SystemCheck.vue?vue&type=script&lang=ts"
export * from "./SystemCheck.vue?vue&type=script&lang=ts"
import style0 from "./SystemCheck.vue?vue&type=style&index=0&id=ccb17fb2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccb17fb2",
  null
  
)

export default component.exports